import type { UseFormRegisterReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Input } from '@/components/shadcn/input'
import { Label } from '@/components/shadcn/label'
import { Textarea } from '@/components/shadcn/textarea'
import { TranslateButton } from '@/components/common/translations/TranslateButton'
import type { PlannedLanguages } from '@/components/common/translations/types.ts'

interface Props {
  titleField: UseFormRegisterReturn
  messageField: UseFormRegisterReturn
  titleTranslations: Record<string, string>
  onTitleTranslationsChange: (translations: Record<string, string>) => void
  messageTranslations: Record<string, string>
  onMessageTranslationsChange: (translations: Record<string, string>) => void
  titlePlannedLanguages?: PlannedLanguages
  onTitlePlannedChange?: (planned: PlannedLanguages) => void
  messagePlannedLanguages?: PlannedLanguages
  onMessagePlannedChange?: (planned: PlannedLanguages) => void
  autoTranslateAll?: boolean
  titleSourceValue?: string
  messageSourceValue?: string
}

export function NotificationContent({
                                      titleField,
                                      messageField,
                                      titleTranslations,
                                      onTitleTranslationsChange,
                                      messageTranslations,
                                      onMessageTranslationsChange,
                                      titlePlannedLanguages,
                                      onTitlePlannedChange,
                                      messagePlannedLanguages,
                                      onMessagePlannedChange,
                                      autoTranslateAll,
                                      titleSourceValue,
                                      messageSourceValue,
                                    }: Props) {
  const { t } = useTranslation('notifications')

  return (
    <>
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="notif-title">
          {t('dialog.content.title')} <span className="text-destructive">*</span>
        </Label>
        <div className="flex gap-2">
          <Input
            id="notif-title"
            required
            placeholder={t('dialog.content.titlePlaceholder')}
            {...titleField}
          />
          <TranslateButton
            dialogTitle={t('dialog.content.titleTranslateTitle')}
            value={titleTranslations}
            onChange={onTitleTranslationsChange}
            plannedLanguages={titlePlannedLanguages}
            onPlannedChange={onTitlePlannedChange}
            autoTranslateAll={autoTranslateAll}
            sourceValue={titleSourceValue}
          />
        </div>
      </div>

      <div className="flex flex-col gap-1.5">
        <Label htmlFor="notif-message">
          {t('dialog.content.message')} <span className="text-destructive">*</span>
        </Label>
        <div className="flex items-start gap-2">
          <Textarea
            id="notif-message"
            required
            placeholder={t('dialog.content.messagePlaceholder')}
            rows={4}
            {...messageField}
          />
          <TranslateButton
            dialogTitle={t('dialog.content.messageTranslateTitle')}
            value={messageTranslations}
            onChange={onMessageTranslationsChange}
            plannedLanguages={messagePlannedLanguages}
            onPlannedChange={onMessagePlannedChange}
            autoTranslateAll={autoTranslateAll}
            sourceValue={messageSourceValue}
          />
        </div>
      </div>
    </>
  )
}
